module.exports = __webpack_public_path__ + "static/media/28.d48ee494.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/28.jpg
// module id = 397
// module chunks = 0